






























































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Str } from '@/modules/shared/helpers'
import { DateHelper } from '@/modules/shared/helpers/date'
import { Notification } from '../../services/notification.service'
import { NotificationModel } from '@/modules/notification/models/notification.model'
import NiknevisLogo from '@/modules/shared/components/shared/NiknevisLogo.vue'
import MarkAllAsReadButton from '@/modules/notification/components/shared/MarkAllAsReadButton.vue'

const { default: VClamp } = require('vue-clamp')

@Component({
  metaInfo: {
    title: 'لیست اعلانات'
  },
  components: {
    MarkAllAsReadButton,
    NiknevisLogo,
    VClamp
  }
})
export default class NotificationsPage extends Vue {
  constructor(
    private readonly str: Str,
    private readonly date: DateHelper
  ) {
    super()
  }

  notifications = Notification.getAllPaginatable()
  markAllAsRead = false

  private get list(): NotificationModel[] {
    return this.notifications.fold(
      () => [],
      value => value ? value.data : [],
      value => value.data,
      () => []
    )
  }

  private get isLoading() {
    return this.notifications.isInProgress()
  }

  private get hasNext() {
    return this.notifications.currentPage < this.notifications.lastPage
  }

  next() {
    if (this.hasNext) {
      this.notifications.next()
    }
  }

  mounted() {
    this.notifications.next()
  }
}
